export default __webpack_public_path__ + "static/media/logo-light.3719c3e4.png";